import logo from './logo.svg';
import './App.css';
import React from 'react';

import allQuestions from './questions.json';

const eqSet = (xs, ys) =>
    xs.size === ys.size &&
    [...xs].every((x) => ys.has(x));

function Question({
  question,
  showAnswer,
  onSelect
}) {
  const [selectedOptions, setSelectedOptions] = React.useState(new Set());
  const answerSet = new Set(question.answers);
  const optionElems = [];
  const correctStyle = {
    border: '1px solid blue'
  };
  const incorrectStyle = {
    border: '1px solid red'
  };
  for (let i = 0; i < question.options.length; i++) {
    let style = {};
    if (selectedOptions.has(i)) {
      style = correctStyle;
    }
    if (showAnswer) {
      if (answerSet.has(i)) {
        style = correctStyle;  // TODO: not selected
      } else if (selectedOptions.has(i)) {
        style = incorrectStyle;
      }
    }
    const elem = <div
      key={i}
      style={style}
      className='option'
      onClick={() => {
        if (showAnswer)
          return;
        let newSelect = new Set(selectedOptions);
        if (selectedOptions.has(i)) {
          newSelect.delete(i);
          setSelectedOptions(newSelect);
        } else {
          newSelect.add(i);
          setSelectedOptions(newSelect);
        }
        if (onSelect) {
          onSelect(newSelect);
        }
      }}
    >{question.options[i]}</div>
    optionElems.push(elem);
  }
  return <div style={{padding: '5px', minWidth: '360px', maxWidth: '700px', width: 'calc(100vw - 20px)'}}>
    <h4>第{question.index}题</h4>
    <div style={{fontSize: 'large', marginBottom: '1em'}}>{question.text}</div>
    {optionElems}
    {showAnswer && <div>你的选择: {new Array(selectedOptions)}, 正确答案: {question.answers}</div>}
  </div>
}

const sampleQuestion = {
  index: 1,
  text: 'test question blablah blablah',
  options: ['A. option a', 'B. option b', 'C. option c', 'D. option d'],
  answers: [0, 1]
}

function SimpleInteractiveSelect({
  question,
  showAnswer,
  errorType,
  onAnswerError
}) {
  showAnswer = !!showAnswer;
  const [show, setShow] = React.useState(showAnswer);
  React.useEffect(_ => {
    setShow(showAnswer);
  }, [showAnswer])
  return <div>
    <Question
      question={question}
      showAnswer={show}
      onSelect={selections => {
        if (selections.size >= question.answers.length) {
          setShow(true);
          if (!eqSet(new Set(question.answers), selections)) {
            // console.error(question.answers, selections);
            onAnswerError(true);
          }
        }
      }}
    />
    {!!errorType && <div style={{color: 'red'}}>错题(type {errorType})</div>}
    <div>
      <input type='button' value='Clear Show' onClick={_ => setShow(false)}></input>
      <input type='button' value='Clear Error' onClick={_ => onAnswerError(false)}></input>
    </div>
  </div>
}

function writeErrors(errors, historicalErrors) {
  errors = [...errors];
  historicalErrors = [...historicalErrors];
  localStorage.setItem('question.errors', JSON.stringify(errors));
  localStorage.setItem('question.historical-errors', JSON.stringify(historicalErrors));
}

function App() {
  const [errors, setErrors] = React.useState(new Set());
  const [historicalErrors, setHistoricalErrors] = React.useState(new Set());
  const [state, setState] = React.useState('none');
  const [showAnswer, setShowAnswer] = React.useState(false);
  const [questions, setQuestions] = React.useState(allQuestions);
  const keyElem = React.useRef();
  const valueElem = React.useRef();
  React.useEffect(_ => {
    let e = localStorage.getItem('question.errors');
    if (e) {
      e = JSON.parse(e);
      setErrors(new Set(e));
    };
    let he = localStorage.getItem('question.historical-errors');
    if (he) {
      he = JSON.parse(he);
      setHistoricalErrors(new Set(he));
    }
  }, []);
  React.useEffect(_ => {
    switch (state) {
      case 'none':
        setQuestions(allQuestions);
        break;
      case 'err':
        setQuestions(allQuestions.filter(q => errors.has(q.id)));
        break;
      case 'herr':
        setQuestions(allQuestions.filter(q => historicalErrors.has(q.id)));
        break;
    
      default:
        break;
    }
  }, [state]);
  const states = ['none', 'err', 'herr'];
  return (
    <div className="App">
      <header className="App-header">
        
      </header>
      <main className='main'>
        <div>
          <select value={state} onChange={event => setState(event.target.value)}>
            {states.map((val, i) => {
              return <option key={i} value={val}>{val}</option>
            })}
          </select>
          <label><input type='checkbox' checked={showAnswer} onClick={_ => setShowAnswer(!showAnswer)}></input>显示答案</label>
        </div>
        <div>
          <input type='text' defaultValue='' ref={keyElem}></input>
          <textarea defaultValue='' ref={valueElem}></textarea>
          <input type='button' value='write local storage' onClick={_ => {
            let key = keyElem.current.value;
            let value = valueElem.current.value;
            if (value === '') {
              localStorage.removeItem(key);
            } else {
              localStorage.setItem(key, value);
            }
          }}></input>
        </div>
        <Question question={sampleQuestion}/>
        {questions.map((q, i) => {
          let errType = 0;
          if (errors.has(q.id)) {
            errType = 1;
          } else if (historicalErrors.has(q.id)) {
            errType = 2;
          }
          return <SimpleInteractiveSelect
            key={i}
            question={q}
            errorType={errType}
            showAnswer={showAnswer}
            onAnswerError={isError => {
              let s = new Set(errors);
              let s1 = new Set(historicalErrors);
              if (isError) {
                s.add(q.id);
                s1.add(q.id);
              } else {
                s.delete(q.id);
              }
              writeErrors(s, s1);
              setErrors(s);
              setHistoricalErrors(s1);
            }}
            />
        })}
      </main>
    </div>
  );
}

export default App;
